import { useState } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * ContactEmailLink — enlace de contacto que copia el email al portapapeles al pulsar
 * (con feedback "¡Copiado!"), en vez de depender solo de `mailto:`. Un `mailto:` no hace
 * nada visible si el usuario no tiene cliente de correo asociado — mala UX cuando es la
 * única vía de contacto ofrecida. Se mantiene el `href` mailto para quien sí lo tenga y
 * para "copiar dirección" del menú contextual.
 */
export function ContactEmailLink({
  email,
  className,
  style,
}: {
  email: string;
  className?: string;
  style?: React.CSSProperties;
}) {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);

  const handleClick = async (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (navigator.clipboard?.writeText) {
      e.preventDefault();
      try {
        await navigator.clipboard.writeText(email);
        setCopied(true);
        window.setTimeout(() => setCopied(false), 2000);
      } catch {
        // Sin permiso de portapapeles → no bloqueamos el mailto nativo.
        window.location.href = `mailto:${email}`;
      }
    }
  };

  return (
    <a
      href={`mailto:${email}`}
      onClick={handleClick}
      title={t('common.contact_email.copy_hint')}
      className={className}
      style={style}
    >
      {copied ? t('common.contact_email.copied') : email}
    </a>
  );
}
